/**
 * useMonthlyDailyComparison Hook
 *
 * Fetches per-day fixed-vs-Agile cost comparison for a given month
 * via the get_daily_agile_comparison RPC.
 */

import { useState, useEffect, useCallback } from 'react'
import { supabase } from '@/supabase-client'

export function useMonthlyDailyComparison(monthStr, refreshKey) {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetch = useCallback(async () => {
    if (!monthStr) return

    setIsLoading(true)
    setError(null)

    try {
      const { data: rows, error: rpcError } = await supabase.rpc(
        'get_daily_agile_comparison',
        { p_month: monthStr }
      )

      if (rpcError) throw rpcError

      setData(rows || [])
    } catch (err) {
      console.error('[useMonthlyDailyComparison] Failed:', err)
      setError(err.message)
      setData([])
    } finally {
      setIsLoading(false)
    }
  }, [monthStr, refreshKey])

  useEffect(() => {
    fetch()
  }, [fetch])

  return { data, isLoading, error, refresh: fetch }
}

export default useMonthlyDailyComparison
